import React, { Component } from 'react';
import { MetricsElement } from 'react-metrics';
import AccessibleElement from '../../ui/components/accessible-element';

import ScrollEvent from './scroll-event';

class TabSelectBar extends Component {
    static defaultProps = {
        enableSticky: true,
    };

    constructor(props) {
        super(props);
        this.tabs = [];
        this.state = {
            tabIndex: 0,
        };
    }

    handleKeyup = (e, index, scroll, isTabSticky) => {
        e.preventDefault();
        let charCode = e.keyCode || e.which;

        if (charCode === 37) {
            //when left arrow key is pressed
            this.setTabFocus(index - 1);
        } else if (charCode === 39) {
            //when right arrow key is pressed
            this.setTabFocus(index + 1);
        } else if (charCode === 13) {
            this.props.handleTabChange(index, scroll, isTabSticky);
        }
    };

    setTabFocus = (index) => {
        if (index >= 0 && index < this.props.tabs.length) {
            this.tabs[index].focus();
        }
    };

    render() {
        const {
            tabs,
            product,
            tabIndex,
            enableSticky,
            handleTabChange,
        } = this.props;
        const children = React.Children.map(
            this.props.children,
            (child, index) => {
                return child;
            }
        );

        return (
            <div>
                <ScrollEvent>
                    {(attachRef, scrollState) => (
                        <div
                            className={`pdp-nav-container${
                                scrollState.isSticky && enableSticky
                                    ? ' fixed-nav'
                                    : ''
                            }`}
                            ref={attachRef}
                        >
                            <MetricsElement
                                element="ul"
                                className="pdp-tabs-nav clearfix"
                            >
                                    {tabs.map((tab, i) => {
                                        if (product) {
                                            return (
                                                <AccessibleElement
                                                    ariaLabel={tab.name}
                                                    element="li"
                                                    key={i}
                                                    tabIndex={
                                                        tabIndex == i ? 0 : -1
                                                    }
                                                    id={`tab_${i}`}
                                                    className={`pdp-nav-tab${
                                                        tabIndex == i
                                                            ? ' selected'
                                                            : ''
                                                    } unstyled`}
                                                    onClick={() =>
                                                        handleTabChange(i, true, scrollState.isSticky)
                                                    }
                                                    onKeyUp={(e) =>
                                                        this.handleKeyup(e, i, true, scrollState.isSticky)
                                                    }
                                                    data-metrics-event-name={
                                                        tab.trackName
                                                    }
                                                    data-metrics-event={`e_${tab.trackName}`}
                                                    data-metrics-product-name={
                                                        product.name ||
                                                        tab.trackName
                                                    }
                                                    data-metrics-details-tab-name={
                                                        tab.name
                                                    }
                                                    ref={(tabRef) =>
                                                        (this.tabs[i] = tabRef)
                                                    }
                                                >
                                                    {tab.name}
                                                </AccessibleElement>
                                            );
                                        } else {
                                            return (
                                                <AccessibleElement
                                                    element="li"
                                                    key={i}
                                                    className={`pdp-nav-tab${
                                                        tabIndex == i
                                                            ? ' selected'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        handleTabChange(i, true, scrollState.isSticky)
                                                    }
                                                    onKeyUp={(e) =>
                                                        this.handleKeyup(e, i, true, scrollState.isSticky)
                                                    }
                                                    aria-label={tab.name}
                                                    data-metrics-event-name="linkClick"
                                                    data-metrics-event="e_linkClick"
                                                    data-metrics-link-id={`${(
                                                        tab.identifier || ''
                                                    ).replace(/\|/g, ':')}`}
                                                    ref={(tabRef) =>
                                                        (this.tabs[i] = tabRef)
                                                    }
                                                >
                                                    {tab.name}
                                                </AccessibleElement>
                                            );
                                        }
                                    })}
                                {children}
                            </MetricsElement>
                        </div>
                    )}
                </ScrollEvent>
            </div>
        );
    }
}

export default TabSelectBar;
